import { useMemo } from 'react';
import { useMap, useMapEvents } from 'react-leaflet';
import { LatLng, PointTuple } from 'leaflet';

const DEFAULT_PADDING: PointTuple = [48, 48];

type KeepInViewProps = {
  target: LatLng | null;
  padding?: PointTuple;
};

/**
 * Keeps the tracked vehicle on screen across wheel and pinch zoom, which anchor on the cursor
 * rather than on the marker. Only `zoomend` is observed, so panning away to inspect something
 * else is left alone — the view is only re-asserted when the user zooms.
 */
export const KeepInView = ({ target, padding = DEFAULT_PADDING }: KeepInViewProps) => {
  const map = useMap();

  useMapEvents(
    useMemo(
      () => ({
        zoomend: () => {
          if (target && !map.getBounds().contains(target)) {
            map.panInside(target, { padding });
          }
        },
      }),
      [map, target, padding],
    ),
  );

  return null;
};
